import { LuIcon, Text } from "@overmap-ai/blocks"
import { type GeoImage, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineGeoImageItemProps {
	geoImage: Stored<GeoImage>
}

export const ProjectTimelineGeoImageItem = memo<ProjectTimelineGeoImageItemProps>((props) => {
	const { geoImage } = props

	const user = useAppSelector(selectUserById(geoImage.created_by ?? -1))

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.GEO_IMAGE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;uploaded geo image to&nbsp;
				<Link from="/$organizationId/$projectId" to="/$organizationId/$projectId/images">
					<Text highContrast className={interactiveTextCva()}>
						<LuIcon icon={modelIconMapping.camera} className="align-sub" />
						&nbsp;project images
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(geoImage.submitted_at)}</Text>
			</Text>

			<Text size="sm" accentColor="base" className="min-w-0 truncate">
				{geoImage.title ?? geoImage.file_name}
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineGeoImageItem.displayName = "ProjectTimelineGeoImageItem"
